export default __webpack_public_path__ + "static/media/1298.0aba85ca.jpeg";